import { observer } from 'mobx-react-lite'
import { TIMELY_PHONE, TIMELY_PHONE_UNFORMATED } from 'constants/timelyInfo'
import { INCIDENT_REPORT_URL, DAILY_NETWORK_TEST_URL } from 'constants/helpCenterUrls'
import PhoneIcon from '@ui-components-3/icons/lib/solid/Phone'

const GeneralInformation = () => {
  return (
    <div className="px-[60px] pb-9 pt-4 flex flex-col items-start gap-4 typography-body-xl text-primary-800 font-medium">
      <h6>Contact Support</h6>
      <a href={`tel:${TIMELY_PHONE_UNFORMATED}`} className="flex items-center mb-3 gap-2.5 text-link-primary">
        <PhoneIcon className="w-5 h-5" aria-hidden="true" />
        <span className="typography-body-l">{TIMELY_PHONE}</span>
      </a>
      <h6>TimelyCare Incident Report Form</h6>
      <a target="_blank" rel="noreferrer" href={INCIDENT_REPORT_URL} className="btn btn-primary">
        CREATE INCIDENT REPORT
      </a>
      <h6>Video Call Diagnostic Tool</h6>
      <a target="_blank" rel="noreferrer" href={DAILY_NETWORK_TEST_URL} className="btn btn-primary">
        Click here to diagnosis video call problems
      </a>
    </div>
  )
}

export default observer(GeneralInformation)
